import React from 'react';
import GridActions from '../../shared/grid/GridActions/GridActions';
import { Domain } from '../../api/permissions_api';
import ChildSeeScoreCell from '../ChildSeeScoreCell/ChildSeeScoreCell';
import { ChildSeeResult } from '../../typings/api-types';
import { DEFAULT_DATE_FILTER_PARAMS, isoDateToCommonFormat } from '../../shared/helpers/dateHelper';
import { ColDef } from 'ag-grid-enterprise';
import { deleteChildSeeResult, useGetChildSeeResults } from '../../api/see_result_api';
import GenericProtectedSearchPage from '../../shared/components/GenericProtectedSearchPage/GenericProtectedSearchPage';
import i18n from 'i18next';

type SearchChildSeeResultPageProps = {};

const getColumns = (onDelete: (objectToDelete: ChildSeeResult) => Promise<any>): ColDef<ChildSeeResult>[] => {
  const t = i18n.t;
  return [
    {
      field: 'child_name',
      headerName: t('common.CHILD_NAME'),
      width: 190,
    },
    {
      field: 'home_name',
      headerName: t('common.HOME_NAME'),
      width: 190,
    },
    {
      field: 'date',
      headerName: t('common.DATE'),
      valueFormatter: (params: any) => {
        return isoDateToCommonFormat(params.value) || '';
      },
      filter: 'agDateColumnFilter',
      filterParams: DEFAULT_DATE_FILTER_PARAMS,
      width: 190,
    },
    {
      headerName: t('seeResult.SCORE'),
      cellRenderer: ChildSeeScoreCell,
      width: 190,
    },
    {
      headerName: t('common.ACTIONS'),
      width: 90,
      cellRenderer: GridActions,
      cellRendererParams: {
        pageUrl: '/child-see-result',
        onDelete: onDelete,
      },
      // Can't disable column
      suppressColumnsToolPanel: true,
    },
  ];
};

const SearchChildSeeResultPage = (props: SearchChildSeeResultPageProps) => {
  return (
    <GenericProtectedSearchPage
      savedPreferencesKey={'see-result'}
      getColumns={getColumns}
      permissionDomain={Domain.CHILD_SEE_RESULT}
      translatePrefix={'seeResult.'}
      useGetListApiHook={useGetChildSeeResults}
      deleteApiFunc={deleteChildSeeResult}
      createForChildPageUrl={'/child-see-result/create/new'}
    />
  );
};

export default SearchChildSeeResultPage;
